export default function usePageScroll() {
  const smoothScroll = (element: HTMLElement | null) => {
    element?.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    });
  };

  const resetScrollPosition = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  };

  return {
    resetScrollPosition,
    smoothScroll,
  };
}
